import { createLink } from '@tanstack/react-router';

import { LinkIconButton, type LinkIconButtonProps } from '@/libs/serenity-ui';

export const RouterIconButtonLink = createLink(({ className, ...props }: LinkIconButtonProps & { className?: string }) => <LinkIconButton {...props} />);
